<script>
import PasswordModal from './../Modals/PasswordModal'
export default {
  name: 'ModalWrapper',
  methods: {
    showModal() {
      this.$modal.show(PasswordModal, {
      }, 
      {
        name: 'PasswordModal',
        classes: "modal modal--container modal--padding_sm",
      })
    },
  },

  render(h) {
    return this.$scopedSlots.default({
      open: () => {
        this.showModal()
      }
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/js/components/ModalWrapper/ModalWrapper.vue